import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Breadcrumb from "../layouts/Breadcrumb";
import Header from '../layouts/Headerthree';
import Footer from '../layouts/Footerthree';
import Content from '../sections/Servicedetail/Content';

class Servicedetail extends Component {
    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>Onitir | Service Detail</title>
                    <meta
                        name="description"
                        content="#"
                    />
                </MetaTags>
                <Header />
                <Breadcrumb breadcrumb={{pagename:'Service Detail'}} />
                <Content/>
                <Footer />
            </Fragment>
        );
    }
}

export default Servicedetail;